import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { en } from '@fullcalendar/core/internal-common';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class WhatsappBroadcastsService {

  private baseUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) { }

  createTemplate(payload: any): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/api/whatsapp/messageTemplate`, payload);
  }

  fetchTemplates(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseUrl}/api/whatsapp`);
  }

  fetchTemplateById(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/api/whatsapp/${id}`);
  }

  sendBroadcastMessage(payload: any): Observable<any>{
    return this.httpClient.post<any>(`${this.baseUrl}/api/whatsapp/broadcast`, payload);
  }
}
